import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center justify-end space-x-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_5 = { class: "mt-6 border rounded-lg border-neutral-100" }
const _hoisted_6 = { class: "tabs flex items-center justify-between pl-6 py-6 pr-3.5 border-b border-neutral-100" }
const _hoisted_7 = { class: "flex items-center space-x-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium" }, "All Records", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "space-y-5" }
const _hoisted_13 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_19 = {
  key: 0,
  class: "text-xs px-1.5 py-[5px] rounded-3xl leading-3 font-semibold text-gray-600 bg-[#f0f1f2]"
}
const _hoisted_20 = {
  key: 1,
  class: "text-xs px-1.5 py-[5px] rounded-3xl leading-3 font-semibold text-green-600 bg-green-100"
}
const _hoisted_21 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_22 = {
  key: 0,
  class: "text-xs px-1.5 py-[5px] rounded-3xl leading-3 font-semibold text-red-600 bg-red-200"
}
const _hoisted_23 = {
  key: 1,
  class: "text-xs px-1.5 py-[5px] rounded-3xl leading-3 font-semibold text-green-600 bg-green-100"
}
const _hoisted_24 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_25 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_26 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_27 = { class: "w-full px-6 border-t py-7" }

import { ref, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { onIonViewWillEnter } from "@ionic/vue";

import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ExportButton from "@/components/buttons/ExportButton.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import EditButton from "@/components/buttons/EditButton.vue";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import RestoreButton from "@/components/buttons/RestoreButton.vue";
import DataTable from "@/components/partials/DataTable.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
// import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import SimplePagination from "@/components/partials/SimplePagination.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import SelectOptions from "@/components/inputs/SelectOptions.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import Personnels from "@/classes/Personnels";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";

import { SelectInterface } from "@/interfaces/pages/BasePageInterface"

// import { filters, items } from "@/interfaces/pages/FilterPageInterface"; // Removed shared state

import assignValues from "@/helpers/assignValues"
import PageLoader from "@/components/loaders/PageLoader.vue"

import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import { hasPermission } from "@/classes/AuthService";
import debounce from "lodash/debounce"
import { RoleTypes } from "../enums/RoleTypes";

// Local reactive state for personnels component
import BaseIndexFilters from "@/classes/General/BaseIndexFilters";
import BaseIndexItems from "@/classes/General/BaseIndexItems";
import { BasePageInterface, BaseItemsInterface } from "@/interfaces/pages/BasePageInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// Local reactive state for personnels component (replacing shared state)
const filters = ref<BasePageInterface>(new BaseIndexFilters());
const items = ref<BaseItemsInterface>(new BaseIndexItems());

/**
 * VARIABLES
 */
const loading = ref<boolean>(false);
const showFilter = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const showExportSuccess = ref<boolean>(false);
const personnelId = ref<number>(0);

const officeOptions = ref<SelectInterface[]>([]);
const userGroupOptions = ref<SelectInterface[]>([]);
const positionOptions = ref<SelectInterface[]>([]);
const userRole = ref();

const tabs = ref<{ name: string; count: number; tab: string|null; allowed: boolean }[]>([
    {
        name: "All",
        count: filters.value.allItemsCount,
        tab: null,
        allowed: true,
    },
    {
        name: "Archived",
        count: 0,
        tab: "archived",
        allowed: true,
    },
    {
        name: "Activity logs",
        count: filters.value.activityLogsCount,
        tab: "activity_logs",
        allowed: true,
    },
]);

const headers: { text: string; haveSort?: boolean }[] = [
    { text: "" },
    { text: "Name", haveSort: true },
    { text: "Office" },
    { text: "User Group" },
    { text: "Position" },
    { text: "Status Verified" },
    { text: "Status" },
    { text: "Date Created" },
];

/**
 * METHODS
 */
const getData = (): void => {
    loading.value = true

    if (filters.value.tab === 'archived' && userRole.value) {
        const isSuperAdmin = userRole.value.role_id == RoleTypes.SUPERADMIN
            || userRole.value.role_id == RoleTypes.SUPERADMIN_IT;
        if (!isSuperAdmin) {
            filters.value.filterOffice = userRole.value.office_id;
        }
    }

    Personnels.index(pickBy(filters.value))
        .then(({ data }) => {
            filters.value = assignValues(filters.value, data);
          
            items.value = data.items;

            officeOptions.value = data.offices;
            positionOptions.value = data.positions;
            userGroupOptions.value = data.userGroups;

            loading.value = false
        })
        .catch((error: any) => {
            console.log(error);
        });
};

const applyFilters = (search: any = null) => {
    showFilter.value = false;
    filters.value.query = search;
    getData();
};

const applyReset = () => {
    filters.value.filterDate = null;
    filters.value.filterOffice = null;
    filters.value.filterPosition = null;
    filters.value.filterUserGroup = null;
   
    showFilter.value = false;
    getData();

};

const paginate = ({ page, rows }): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })
    getData();
};

const updateTab = (currentTab: string) => {
    filters.value.tab = currentTab;
    filters.value.page = 1;
    applyFilters();
};

/**
 * MODALS
 */
const showDeleteModal = (item: any): void => {
    showConfirmation.value = true;
    personnelId.value = item.id;
};

const closeDeleteModal = (): void => {
    showSuccess.value = false;
};

const deleteRecord = (): void => {
    Personnels.delete(personnelId.value)
        .then(() => {
            showSuccess.value = true;
            showConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const showRestoreModal = (item: any): void => {
    showRestoreConfirmation.value = true;
    personnelId.value = item.id;
};

const closeRestoreModal = (): void => {
    showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {
    Personnels.restore(personnelId.value)
        .then(() => {
            showRestoreSuccess.value = true;
            showRestoreConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const exportPerosnnel = (): void => {
    loading.value = true
    Personnels.export(filters.value)
        .then(() => {
            loading.value = false
            showExportSuccess.value = true;
        })
        .catch((error) => console.log(error));
};


const closeExportPerosnnel = (): void => {
    showExportSuccess.value = false;
};

const canCreate = () => {
    let hasAccess = false;
    if (userRole.value?.role_id == RoleTypes.SUPERADMIN 
    || userRole.value?.role_id == RoleTypes.SUPERADMIN_IT 
    || userRole.value?.role_id == RoleTypes.OFFICE_ADMIN) {
        hasAccess = true;
    }

    return hasAccess;
}

/**
 * WATCHERS
 */
watch(
    () => filters.value.query,
    debounce(() => {
        filters.value.page = 1;
        getData();
    }, 1000)
);

// onMounted(() => {
//     filters.value.filterOffice = route.query.office;

//     getData();
// });

onIonViewWillEnter(() => {
    filters.value.filterOffice = route.query.office;
    userRole.value =  JSON.parse(localStorage.getItem('user')); 

    getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Personnel",
            description: "View the relevant in the system."
          }),
          _createElementVNode("div", _hoisted_3, [
            (_unref(hasPermission)('can-view-admin'))
              ? (_openBlock(), _createBlock(ExportButton, {
                  key: 0,
                  onClick: exportPerosnnel
                }))
              : _createCommentVNode("", true),
            (_unref(hasPermission)('can-create-admin'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/personnel/create')))
                }, [
                  (canCreate())
                    ? (_openBlock(), _createBlock(ButtonComponent, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                          _hoisted_4
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(TabComponent, {
                typeThree: "",
                "active-tab": filters.value.tab,
                tabs: tabs.value,
                "onUpdate:tab": _cache[1] || (_cache[1] = (value) => updateTab(value))
              }, null, 8, ["active-tab", "tabs"])
            ])
          ]),
          (filters.value.tab != 'activity_logs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(DataTable, {
                  headers: headers,
                  "no-action": false,
                  count: items.value.total,
                  hasSearch: true,
                  searchPlaceholder: "Search personnel",
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  "onUpdate:searchText": _cache[10] || (_cache[10] = (value) => (filters.value.query = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (showFilter.value = true))
                      }, _hoisted_11),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[7] || (_cache[7] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[8] || (_cache[8] = ($event: any) => (applyReset())),
                        "onApply:filters": _cache[9] || (_cache[9] = ($event: any) => (applyFilters()))
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(DatePicker, {
                              id: "date_created",
                              name: "date_created",
                              label: "Date Created",
                              range: true,
                              modelValue: filters.value.filterDate,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.filterDate) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(SelectOptions, {
                              options: officeOptions.value,
                              label: "Office",
                              id: "office",
                              name: "office",
                              placeholder: "Select..",
                              modelValue: filters.value.filterOffice,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.filterOffice) = $event))
                            }, null, 8, ["options", "modelValue"]),
                            _createVNode(SelectOptions, {
                              options: userGroupOptions.value,
                              label: "User Group",
                              id: "user_group",
                              name: "user_group",
                              placeholder: "Select..",
                              modelValue: filters.value.filterUserGroup,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.filterUserGroup) = $event))
                            }, null, 8, ["options", "modelValue"]),
                            _createVNode(SelectOptions, {
                              options: positionOptions.value,
                              label: "Position",
                              id: "position",
                              name: "position",
                              placeholder: "Select..",
                              modelValue: filters.value.filterPosition,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.filterPosition) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.id), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.office_name), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item.user_group_name), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(item.position_name), 1),
                        _createElementVNode("td", _hoisted_18, [
                          (item.status == 'Unverified')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Unverified "))
                            : _createCommentVNode("", true),
                          (item.status == 'Verified')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Verified "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          (!item.is_active)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, " In-Active "))
                            : _createCommentVNode("", true),
                          (item.is_active)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Active "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(item.created_at_formatted), 1),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            (!filters.value.tab)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_unref(hasPermission)('can-update-admin'))
                                    ? (_openBlock(), _createBlock(EditButton, {
                                        key: 0,
                                        class: "shrink-0",
                                        onClick: ($event: any) => (_unref(router).replace(`/personnel/edit/${item.id}`))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_unref(hasPermission)('can-archive-admin'))
                                    ? (_openBlock(), _createBlock(DeleteButton, {
                                        key: 1,
                                        class: "shrink-0",
                                        onClick: ($event: any) => (showDeleteModal(item))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (filters.value.tab == 'archived')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_unref(hasPermission)('can-archive-admin'))
                                    ? (_openBlock(), _createBlock(RestoreButton, {
                                        key: 0,
                                        class: "shrink-0",
                                        onClick: ($event: any) => (showRestoreModal(item))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count"])
              ]))
            : _createCommentVNode("", true),
          (filters.value.tab == 'activity_logs')
            ? (_openBlock(), _createBlock(ActivityLogsTable, {
                key: 1,
                items: items.value
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(SimplePagination, {
              numRows: filters.value.rows,
              currentPage: items.value.current_page,
              "last-page": items.value.last_page,
              onUpdate: _cache[11] || (_cache[11] = (value) => paginate(value))
            }, null, 8, ["numRows", "currentPage", "last-page"])
          ])
        ])
      ]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[12] || (_cache[12] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[13] || (_cache[13] = ($event: any) => (deleteRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record",
        content: "Are you sure you wish to delete this record?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[14] || (_cache[14] = ($event: any) => (closeDeleteModal())),
        "action-text": "Close",
        title: "Record Deleted!",
        content: "Selected record has been successfully deleted!"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showRestoreConfirmation.value,
        onCancel: _cache[15] || (_cache[15] = ($event: any) => (showRestoreConfirmation.value = false)),
        onConfirm: _cache[16] || (_cache[16] = ($event: any) => (restoreRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Restore Record",
        content: "Are you sure you wish to restore this record?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showRestoreSuccess.value,
        onConfirm: _cache[17] || (_cache[17] = ($event: any) => (closeRestoreModal())),
        "action-text": "Close",
        title: "Record Restored!",
        content: "Selected record has been successfully restored!"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showExportSuccess.value,
        onConfirm: _cache[18] || (_cache[18] = ($event: any) => (closeExportPerosnnel())),
        "action-text": "Close",
        title: "Personnels Exported!",
        content: "Please check your email for the exported personnels"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})